import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Editar posição", -1)
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_3 = { class: "flex justify-between gap-2 w-full" }

import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { useToast } from 'vue-toastification'
import Network from '@/Network'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'updatePosition',
  props: {
  positionId: {
    type: Number,
    required: true
  },
  scheduleId: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



const modalName = EModals.UPDATE_POSITION
const { modals } = storeToRefs(useModalStore())
const scheduleStore = useScheduleStore()
const modalStore = useModalStore()
const toast = useToast()
const { notifyError } = useErrorToast()

const data = ref<{
  positionName: string
}>()
const errors = ref<{ positionName: string }>({
  positionName: ''
})

const isLoading = ref(false)

onMounted(async () => {
  if (!props.positionId) return
  clearErrs()

  try {
    isLoading.value = true
    const apiResponse = await Network.position.getById(props.positionId)
    data.value = {
      positionName: apiResponse.name
    }
  } finally {
    isLoading.value = false
  }
})

const hasError = () => {
  let errorFound = false
  if (!data.value?.positionName || data.value.positionName.trim().length === 0) {
    errors.value.positionName = 'Informe um nome para posição'
    errorFound = true
  }
  return errorFound
}

const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
  data.value = undefined
  clearErrs()
}

const handleSubmit = async () => {
  if (!data.value || hasError()) {
    toast.error('Dados inválidos ou não preenchidos')
    return
  }

  try {
    isLoading.value = true

    await Network.position.update(props.positionId, {
      name: data.value.positionName,
      scheduleId: props.scheduleId
    })
    // Refetch isolado: a edição já foi persistida — falha do reload não pode
    // interromper o fluxo de sucesso do modal.
    await scheduleStore
      .getSchedulesForPage()
      .catch((error) => notifyError(error, 'Não foi possível recarregar as escalas'))
    modalStore.alertDescription = 'Posição editada com sucesso!'
    modalStore.toggleModal(modalName)
    modalStore.toggleShowAlert()
  } finally {
    isLoading.value = false
  }
}

const clearErrs = () => {
  errors.value.positionName = ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    isFilterModal: ""
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlineButton, {
          width: "119px",
          onClick: handleToggleModal,
          text: "Cancelar"
        }),
        _createVNode(FilledButton, {
          disabled: isLoading.value,
          loading: isLoading.value,
          text: "Editar",
          width: "119px",
          onClick: handleSubmit
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      (!data.value || isLoading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_text_field, {
              modelValue: data.value.positionName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.positionName) = $event)),
              label: "Nome da Posição*",
              class: "w-full",
              color: "primary20",
              variant: "outlined",
              errorMessages: errors.value.positionName
            }, null, 8, ["modelValue", "errorMessages"])
          ]))
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})